import { Editor } from "@tinymce/tinymce-react";
import React, { useState, useRef, useEffect, useContext } from "react";
import numberToWords from "number-to-words";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useNavigate, useParams } from "react-router-dom";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { InvoiceEditorContext } from "./InvoiceTable";
import moment from "moment";

const initialTableData = [
  {
    sNo: 1,
    refNo: "3610579 01",
    reference: "HT018301-NK-IN-1202205QR0012(RET)(MISSING)",
    description: "KITCHEN CABINETS",
    hsCode: 94034010,
    countryOfOrigin: "Germany",
    quantity: 1,
    noOfPacks: 1,
    invoiceAmount: "10.00",
  },
  {
    sNo: 2,
    refNo: "3774258 00",
    reference: "HT020201-NK-H202210QR0031(RET)",
    description: "KITCHEN CABINETS",
    hsCode: 94034010,
    countryOfOrigin: "Germany",
    quantity: 1,
    noOfPacks: 93,
    invoiceAmount: "18,273.68",
  },
  {
    sNo: 3,
    refNo: "3774258 01",
    reference: "HT020201-NK-H202210QR0031(RET)(WINE CELLAR)",
    description: "KITCHEN CABINETS",
    hsCode: 94034010,
    countryOfOrigin: "Germany",
    quantity: 1,
    noOfPacks: 1,
    invoiceAmount: "790.67",
  },
];

const InvoiceEditor = () => {
  const [showInvoice, setShowInvoice, invoiceType, selectedInvoiceRows, genInvoice, selectedLogisticRows] = useContext(InvoiceEditorContext);
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState("");
  const [tableData, setTableData] = useState(selectedInvoiceRows);
  const navigate = useNavigate();
  const { containerId } = useParams();
  const generateInvoiceUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.generateInvoice}`;

  const containerNumber = selectedLogisticRows[0]?.containerNo;
  const lcNumber = selectedLogisticRows[0]?.lcNumber;

  const defaultContent = () => {
    const initialContent = `
      <div style="display: flex; justify-content: flex-end;">
        <img src="/assets/images/logo/LOGO.png" alt="Image" class="logo">
      </div>
  
      <div style="display: flex; justify-content: flex-end;">
        <p style="text-align: left;">
          NOLTE FZE <br />
          Dubai Silicon Oasis HQ, <br />
          Office: 404-405, E Wing, <br />
          P.O.Box No. 341265, Dubai, UAE
        </p>
      </div>
  
      <p style="text-align: center; font-size: 24px;"><strong>${invoiceType}<strong></p>
  
      <div style="display: flex; justify-content: space-between; margin-bottom: 32px;">
        <div style="flex-direction: column; text-align: left;">
            <p style="margin: 0;">HBI  CO. LTD</p>
            <p style="margin: 0;">1F., No. 260, Tun Hua N. Road</p>
            <p style="margin: 0;">R.O.C.</p>
            <p style="margin: 0;">PO Box. No.</p>
        </div>
  
        <div style="flex-direction: column; text-align: left;">
          <p style="margin: 0;">Invoice No: ${genInvoice[0]?.invoiceNo}</p>
          <p style="margin: 0;">Date: ${moment().format("DD-MM-YYYY")}</p>
          <p style="margin: 0;">Terms Of Delivery: Ex-Works</p>
          <p style="margin: 0;">Payment Term: LC at 120 days</p>
          <p style="margin: 0;"> after the shipment date</p>
        </div>
      </div>
  
      <p>TAIWAN, PROVINCE OF CHINA</p>
  
      <table style="margin-left: auto; margin-right: auto;" border="1">
        <thead>
          <tr>
            <th><strong>S.No.</strong></th>
            <th><strong>Ab Number</strong></th>
            <th><strong>Description</strong></th>
            <th><strong>HS Code</strong></th>
            <th><strong>Country of Origin</strong></th>
            <th><strong>Qty</strong></th>
            <th><strong>No. Of Pkts.</strong></th>
            <th><strong>Amount (EUR)</strong></th>
          </tr>
        </thead>
        <tbody>
          ${selectedInvoiceRows
            .map((item, index) => generateTableRow(item, index))
            .join("")}
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" style="text-align: center"><strong>Total</strong></td>
            <td style="text-align: right"><strong>${totalQty()}</strong></td>
            <td style="text-align: right"><strong>${totalNoOfPacks()}</strong></td>
            <td style="text-align: right"><strong>${totalAmount()}</strong></td>  
          </tr>
        </tfoot>
      </table>

      <p>Amount In words: Euro ${numberToWords
        .toWords(Math.floor(parseFloat(totalAmount().replace(/,/g, ""))))
        .replace(/\b\w/g, (match) => match.toUpperCase())} and 
        ${numberToWords
          .toWords(
            Math.round((parseFloat(totalAmount().replace(/,/g, "")) - Math.floor(parseFloat(totalAmount().replace(/,/g, "")))) * 100)
          )
          .replace(/\b\w/g, (match) => match.toUpperCase())} Cents only</p>

      <p style="margin-bottom: 0px"><strong>Container Number: ${containerNumber}</strong></p>
      <p style="margin-top: 0px"><strong>LC No.: ${lcNumber}</strong></p>
    `;
    return initialContent;
  };

  const generateTableRow = (rowData, index) => {
    return `
    <tr>
      <td>${index + 1}</td>
      <td>${rowData.abNumber}</td>
      <td>${rowData.description}</td>
      <td>${rowData.hsCode}</td>
      <td>${rowData.country}</td>
      <td style="text-align: right">${rowData.quantity}</td>
      <td style="text-align: right">${rowData.noOfPacks}</td>
      <td style="text-align: right">${rowData.invoiceAmount}</td>
    </tr>
  `;
  };

  const totalQty = () => {
    return selectedInvoiceRows?.reduce((total, item) => total + item?.quantity, 0);
  };

  const totalNoOfPacks = () => {
    return selectedInvoiceRows?.reduce((total, item) => total + item?.noOfPacks, 0);
  };

  const totalAmount = () => {
    const totalInvoiceAmount = selectedInvoiceRows?.reduce((total, item) => total + item?.invoiceAmount, 0)
    const formattedNumbers = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(totalInvoiceAmount);

    return formattedNumbers;
  };

  const handleEditorChange = (content, editor) => {
    setEditorContent(content);
  };

  const handleSaveClick = async () => {
    //     if (editorRef.current) {
    //       const editorContent = editorRef.current.getContent();

    //       // Convert HTML content to data URL
    //       const dataUrl = `data:text/html;charset=utf-8,${encodeURIComponent(
    //         editorContent
    //       )}`;

    //       // Create a Blob with the data URL
    //       const blob = new Blob([dataUrl], { type: "application/pdf" });
    //       const staticPDFFile = new File([dataUrl], "invoice.pdf", {
    //         type: "application/pdf",
    //       });


    const editor = tinymce.get("myEditor");
    const content = editor.getContent();
    const blob = new Blob([content], { type: "application/pdf" });
    const file = new File([blob], "content.pdf", { type: "application/pdf" });
    console.log("file", file);
    const formData = new FormData();
    formData.append("File", file);
    

    // const uploadDocUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.uploadMultipleFile}?documentName=${"Invoice"}&documentType=${"pdf"}&issueDate=${"2023-07-23"}&expiryDate=${"2023-10-25"}&empId=${106}&uploadFile=${"fileName"}&notifactionDays=${"46"}`;
    // const responce = await OAuthService.uploadFile(uploadDocUrl, formData);
    // console.log("responce:", responce);

    //       // Create a download link and trigger a click event to download the PDF
    //       // const link = document.createElement("a");
    //       // link.href = URL.createObjectURL(blob);
    //       // link.download = "invoice.pdf";
    //       // link.click();
    // }
  };

  const contentStyle = `
    table {
      width: 100%;
      border-collapse: collapse;
      border: 2px solid gray;
    }
    table td {
      border: 1px solid #333;
      padding: 5px;
    }
    .logo {
      max-width: 100%;
      height: auto;
    }
  `;

  return (
    <div>
      <Dialog
        open={showInvoice}
        onClose={() => setShowInvoice(false)}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogContent>
        <div className="flex justify-between items-center my-16">
        <Button
          onClick={() => {
            setShowInvoice(false);
          }}
          variant="contained"
          color="warning"
        >
          <FuseSvgIcon>heroicons-outline:arrow-circle-left</FuseSvgIcon>
        </Button>
        <Button variant="contained" onClick={handleSaveClick} color="warning">
          <Typography color="black">Send Invoice</Typography>
        </Button>
      </div>
      <Editor
        id="myEditor"
        ref={editorRef}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={defaultContent()}
        apiKey="x86rnkwjobnm3lyvpx50rtpcbgjebvme5vduj12ek7y29hv7"
        init={{
          // height: 940,
          min_height: 940,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "print",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "fullscreen",
            "media",
            "table",
            "paste",
            "code",
            "wordcount",
            "emoticons",
          ],
          toolbar:
            "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | \
            | forecolor backcolor | code print | table | bullist numlist outdent indent | removeformat | preview media | emoticons",
          content_style: contentStyle,
          statusbar: false,
        }}
        onEditorChange={handleEditorChange}
      />
        </DialogContent>
      </Dialog>
      
    </div>
  );
};

export default InvoiceEditor;
